@if (!mobile) {
    <div class="settings">
        <div class="trigger" [cdkMenuTriggerFor]="menu">
            <div class="icon">
                <i class="fa-solid fa-chevron-down"></i>
            </div>
            <div class="name">Toon ploegen</div>
        </div>
    </div>
} @else if (mobile) {
    <div class="mobile-filter">
        <ng-container *ngTemplateOutlet="filter"></ng-container>
    </div>
}

<ng-template #menu>
    <div class="menu" cdkMenu>
        <ng-container *ngTemplateOutlet="filter"></ng-container>
    </div>
</ng-template>

<ng-template #filter>
    <div>Selecteer ploegen</div>
    <mat-selection-list [formControl]="fcTeams">
        @for (type of entityTypes; track type) {
            <mat-list-option [value]="type.key" checkboxPosition="before">
                {{ type.plural_name }}
            </mat-list-option>
        }
    </mat-selection-list>
</ng-template>
